function parseCountry(enLocale) {
  var countrySAR = ['HK', 'MO'];
  var enLocaleCountries = enLocale;
  countrySAR.forEach(function (code) {
    enLocaleCountries.countries[code] = "".concat(enLocale.countries[code], " SAR");
  });
  return enLocaleCountries;
}

export { parseCountry };